import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/applications")({
  component: lazyRouteComponent(() => import("./-pages/admin.applications")),
  head: () => ({ meta: [{ title: "Lecmo · طلبات السفراء" }] }),
});
